import { Injectable, EventEmitter, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServicesSharedService {
  @Output() validatorFormShow: EventEmitter<any> = new EventEmitter();

  constructor() {
  }


}
